<template>
  <div>
    <div class="search-box">
      <div class="ipt-box">
        <img class="icon" src="../assets/icons/icon_search.png" alt="" @click="getProductList">
        <input type="text" placeholder="请输入关键词进行搜索" v-model="searchValue" @keyup.enter="getProductList" />
        <a href="javascript:;" :class="['btn-clear', {show: searchValue}]" @click="searchValue = ''">
          <van-icon name="cross" />
        </a>
      </div>
    </div>
    <div class="ship-list" v-show="!hasBindTicket">
      <swiper class="ship-list-swiper" :options="swiperOption">
        <swiper-slide
          v-for="shipItem in shipList"
          :key="shipItem.value"
          :class="['classify-item', {cur: shipItem.value === shipActive}]"
          :data-val="shipItem.value">
          <span :data-val="shipItem.value">{{shipItem.name}}</span>
        </swiper-slide>
      </swiper>
    </div>
    <van-collapse class="classify-list" v-model="activeNames" :border="false">
      <van-collapse-item v-for="(item, index) in classifyList" :key="index" :name="item.categoryName" :value="activeNames.indexOf(item.categoryName) >= 0 ? '收起' : '展开'">
        <span slot="title" class="label-classify">{{item.categoryName}}</span>
        <div class="product-list-box">
          <product-list :list="item.productList" />
        </div>
        <div class="interval"></div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import ProductList from './booking/ProductList'
import { shipList } from '@/utils/dict'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import uniq from 'lodash/uniq'

export default {
  name: 'PageProductSearch',

  components: {
    ProductList
  },

  data () {
    return {
      shipList,
      searchValue: '',
      classifyList: [],
      activeNames: [],
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 11,
        on: {
          click: swiper => {
            this.shipActive = swiper.target.attributes['data-val'].nodeValue
            this.getProductList()
          }
        }
      },
      shipActive: shipList[0].value
    }
  },

  activated () {
    if (this.$route.query.keyword) {
      this.searchValue = this.$route.query.keyword
      this.getProductList()
    }
  },

  computed: {
    hasBindTicket () {
      return Boolean(this.$store.state.bindTicket)
    }
  },

  methods: {
    async getProductList () {
      showLoading()
      this.classifyList = []
      const params = {
        keyword: this.searchValue.trim()
      }
      if (!this.hasBindTicket) params.shipCode = this.shipActive
      const { errCode, errMsg, data } = await api.searchProductByName(params)
      hideLoading()
      if (errCode === 0) {
        if (data.rows.length) {
          const categoryNames = uniq(data.rows.map(x => x.categoryName))
          this.activeNames = categoryNames
          for (let i = 0; i < categoryNames.length; i++) {
            this.classifyList.push({
              categoryName: categoryNames[i],
              productList: data.rows.filter(x => x.categoryName === categoryNames[i])
            })
          }
        }
      } else {
        showAlert(errMsg || '查询失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  padding: 24px 35px 28px;
  .ipt-box {
    position: relative;
    display: flex;
    align-items: center;
    height: 72px;
    border-radius: 36px;
    background-color: #fff;
    overflow: hidden;
    .icon {
      width: 29px;
      height: 29px;
      margin: 0 18px 0 40px;
    }
    input {
      flex: 1;
      height: 34px;
      margin-top: 3px;
      padding-right: 78px;
      font-size: 24px;
      color: #333;
      line-height: 34px;
      border: none;
      outline: none;
    }
    .btn-clear {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 42px;
      height: 42px;
      margin-top: -21px;
      font-size: 20px;
      color: #333;
      border-radius: 50%;
      opacity: 0;
      transition: all .3s;
      background-color: #e5e5e5;
      &.show {
        opacity: 1;
        right: 20px;
      }
    }
  }
}
.ship-list {
  padding: 2px 50px 28px;
}
.ship-list-swiper {
  width: 100%;
  .classify-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 48px;
    padding: 0 34px;
    border-radius: 24px;
    font-size: 24px;
    color: #1174b8;
    background-color: #fff;
    &.cur {
      .btn-linear-gradient;
      color: #333;
    }
  }
}
.classify-list {
  ::v-deep .van-cell {
    padding: 18px .5rem;
    &:not(:last-child)::after {
      visibility: hidden;
    }
  }
  ::v-deep .van-collapse-item__content {
    padding: 0;
  }
  ::v-deep .van-cell__right-icon {
    margin-top: -1.5px;
    color: #1174b8;
  }
  ::v-deep .van-cell__value {
    font-size: .24rem;
    color: #1174b8;
  }
  .label-classify {
    display: inline-block;
    height: 46px;
    padding: 0 24px;
    border-radius: 23px;
    font-size: 24px;
    color: #333;
    line-height: 46px;
    background-color: #f0f0f0;
  }
  .product-list-box {
    padding: 0 50px 30px;
  }
  ::v-deep .product-item {
    border: 1Px solid #eaeaea;
    border-radius: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .interval {
    height: 30px;
    background-color: #f0f0f0;
  }
}
</style>
